import PolicyLoading from "src/Candidate/atoms/PolicyLoading";
import PolicyError from "src/Candidate/atoms/PolicyError";
import PolicyEmpty from "src/Candidate/atoms/PolicyEmpty";
import PolicySectionHeading from "src/Candidate/atoms/PolicySectionHeading";
import PolicyLabeledContent from "src/Candidate/atoms/PolicyLabeledContent";
import PolicyHtmlContent from "src/Candidate/atoms/PolicyHtmlContent";
import PolicyPlainContent from "src/Candidate/atoms/PolicyPlainContent";
import PolicyLastUpdated from "src/Candidate/atoms/PolicyLastUpdated";
import {
  LegalPolicyContentProps,
  ContentItem,
} from "./LegalPolicyContent.types";
import styles from "./LegalPolicyContent.module.css";

function normalize(item: string | ContentItem): ContentItem {
  return typeof item === "string" ? { text: item } : item;
}

function isHtml(str: string): boolean {
  return /<[a-z][\s\S]*>/i.test(str);
}

export default function LegalPolicyContent({
  sections,
  loading,
  error,
  lastUpdated,
}: LegalPolicyContentProps): JSX.Element {
  if (loading) {
    return <PolicyLoading />;
  }

  if (error) {
    return <PolicyError error={error} />;
  }

  if (!sections || sections.length === 0) {
    return <PolicyEmpty />;
  }

  return (
    <div className={styles.container}>
      {sections.map((section) => (
        <div key={section.heading} className={styles.section}>
          <PolicySectionHeading heading={section.heading} />
          <div className={styles.contentList}>
            {section.content.map((raw) => {
              const item = normalize(raw);
              const contentKey = `${section.heading}-${
                typeof raw === "string"
                  ? raw.substring(0, 40)
                  : item.text.substring(0, 40)
              }`;
              if (item.label !== undefined && item.label !== null) {
                return (
                  <PolicyLabeledContent
                    key={contentKey}
                    label={item.label}
                    text={item.text}
                  />
                );
              }
              if (isHtml(item.text)) {
                return <PolicyHtmlContent key={contentKey} html={item.text} />;
              }
              return (
                <PolicyPlainContent
                  key={contentKey}
                  text={item.text}
                  bold={item.bold}
                />
              );
            })}
          </div>
        </div>
      ))}
      {lastUpdated && <PolicyLastUpdated date={lastUpdated} />}
    </div>
  );
}
